import React from "react";
import AccessDeniedResponse from "./AccessDeniedResponse";

const DataResponse = ({ error }) => {
  const { statusCode } = error.error;

  console.log(error);

  switch (statusCode) {
    case 403:
      return <AccessDeniedResponse />;
    default:
      return null;
  }
};

export default DataResponse;
